import React from 'react';
import { Modal } from "antd";
import { closeLogin, judgeIsLogin } from '../../common/utils';
import './login.less';

interface IProps {};

export default function index(props: IProps) {
  const goLogin = () => {
    judgeIsLogin();
  }
  return (
    <Modal
      visible={true}
      // title="弹窗"
      footer={null}
      onCancel={closeLogin}
      keyboard={false}
      maskClosable={false}
    >
      <div className="login_modal">
        <p>登陆提醒</p>
        <div className="bold">您尚未登陆</div>
        <div className="text">登录后才能进行课程学习<span onClick={goLogin}>去登录</span></div>
      </div>
    </Modal>
  )
}
